import { DATA_SET_CODES } from '../../config/datasets';

export function DataSetCodeList({ dataSetIds }) {
  return <>{dataSetIds?.map((id) => (DATA_SET_CODES[id] || '') + ' ')}</>;
}
